import { updateSurveyStatus } from '@goldcast/api/backend';

import { surveyApiClient } from './apiClient';

import { getCloudFrontUrl, getEnv } from '@/constants';

/**
 *
 * @param {*} surveyId
 * @param {*} params { broadcast: string, state:"OPEN"|"CLOSE"}
 * @returns
 */
export function updateSurveyState(surveyId, params) {
  return updateSurveyStatus({ id: surveyId, body: params });
}

/**
 *
 * @param {*} surveyId
 * @returns
 */
export function getSurvey(surveyId) {
  return fetch(`${getCloudFrontUrl('CLOUDFRONT_URL')}surveys/${getEnv('VUE_APP_ENV')}/${surveyId}.json`)
    .then(res => res.json())
    .catch(err => {
      throw err;
    });
}

/**
 * @param {broadcast_id, survey_id, event_id, responses}
 */

export function saveUserSurveyResponse(params) {
  return surveyApiClient.post('/save', params);
}
